<template>
    <div class="vue-mobile-active-garage-block" :class="{'no-garage': hasActiveGarage === false}">
        <template v-if="hasActiveGarage === true">
                <h2 class="virtual-h4">
                    Uw CarProf <br>
                    <a :href="activeGarage.url">{{ activeGarage.title }}</a>
                </h2>

                <div class="info d-flex justify-content-between align-content-center mt-4">
                    <div class="contact">
                        <address class="mb-0">
                            <p>
                                {{ activeGarage.streetNumber }}<br>
                                {{ activeGarage.postalCodePlace }}<br>
                            </p>

                            <p class="mb-0">
                                <template v-if="this.parsedPhonenumber">
                                    <a :href="`tel:${ parsedPhonenumber }`">{{ activeGarage.tel }}</a><br>
                                </template>

                                Email: <a :href="`mailto:${activeGarage.email}`">{{ activeGarage.email }}</a>
                            </p>
                        </address>
                    </div>

                    <div class="klantenvertellen" v-if="hasKlantenvertellen">
                        {{ activeGarage.klantenvertellen.averageScore }}
                    </div>
                </div>

                <div class="mt-4">
                    <a :href="`${activeGarage.url}/afspraak-maken`" class="btn-arrow">Afspraak maken</a>

                    <a :href="`${activeGarage.url}/offerte-aanvragen`" class="btn-arrow-inverse">Offerte aanvragen</a>
                </div>

                <hr class="divider">

                <a href="/vestigingen" class="cta-link">Andere vestiging selecteren</a>
        </template>
    </div>
</template>

<script>
import ActiveGarageMixin from "../mixins/ActiveGarageMixin";

export default {
    name: "ActiveGarageBlock",

    mixins: [ActiveGarageMixin],
}
</script>